import { useDrizzleStudio as useDrizzleStudioNative } from "expo-drizzle-studio-plugin";
import type { DrizzleAsyncSQLiteClient } from "@-/com.npmjs.drizzle-orm/expo-sqlite-async/client";
import type { SQLiteDatabase } from "expo-sqlite";

function isNativeExpoSqliteDatabase(
  value: DrizzleAsyncSQLiteClient | SQLiteDatabase,
): value is SQLiteDatabase {
  return (
    typeof value === "object" &&
    value !== null &&
    typeof Reflect.get(value, "databasePath") === "string" &&
    typeof Reflect.get(value, "nativeDatabase") === "object"
  );
}

/**
 * Drizzle `$client` handles are native `SQLiteDatabase` instances on iOS/Android.
 * Web SQLocal/op-sqlite shims are ignored (pass `null`).
 */
export function useDrizzleStudio(database: DrizzleAsyncSQLiteClient | SQLiteDatabase | null): void {
  const nativeDatabase =
    database !== null && isNativeExpoSqliteDatabase(database) ? database : null;
  useDrizzleStudioNative(nativeDatabase);
}
